export function Rsvp() {
    return (
        <>
            <a
                href="https://withjoy.com/mairead-with-conor/rsvp"
                target="_blank"
                rel="noopener noreferrer"
                className={"rsvpButton"}
            >
                Click Me to RSVP :)
            </a>
        </>
    )
}